import React from 'react';
import { SERVER_IP, PORT, ud, jwt } from '../../Server'
import CallManager from '../VideoChat/CallManager'
import swal from 'sweetalert';
import axios from 'axios';

var socket;
var resetState = {
    user_list: [],
    calling: false,
    calling_mode: "",
    room_id: 0,
    to_calling_obj: undefined, // store call_type:"video",callers:[]
    incomming_data: {},
    isCallRoomEventActive: false
}
class CallingChannel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            server: `${SERVER_IP}`,
            user_list: [],
            calling: false,
            calling_mode: "",
            socket_id: "",
            room_id: 0,
            to_calling_obj: undefined, // store call_type:"video",callers:[]
            incomming_data: {},
            isCallRoomEventActive: false,
            Callers: []
        }
    }
    componentWillReceiveProps(props) {
        this.connectToSocket(props.socket)

        if (this.state.calling_mode === "") {
            if (props.to_calling_obj) {
                if (this.state.to_calling_obj == undefined) {
                    this.setState({ to_calling_obj: props.to_calling_obj })
                    this.callInitiation(props.to_calling_obj);
                }
            }
        }
    }
    componentDidMount() {
        this.RemoveOldToUserHistory();
        this.connectToSocket(this.props.socket)
    }
    connectToSocket = (socketinfo) => {
        socket = socketinfo;
        if (socket) {
            if (this.state.isCallRoomEventActive == false) {
                this.InncommingCalling();
            }
        }
    }
    RemoveOldToUserHistory = () => {
        this.setState(resetState)
    }
    InncommingCalling = () => {
        var _this = this;
        this.setState({ isCallRoomEventActive: true })
        socket.on("INCOMING", function (data) {
            if (data.call_flag_name == "INCOMING_CALL") {
                _this.setState({
                    calling: true, calling_mode: "INCOMING_CALL", room_id: Number(data.room_id),
                    incomming_data: {
                        call_flag_name: data.call_flag_name,
                        room_id: Number(data.room_id),
                        callerList: JSON.parse(data.callerList)
                    }
                })
            }

            else if (data.call_flag_name == "ROOM_ERROR") {
                _this.RemoveOldToUserHistory()
            }
        })
        socket.on("CALL_ROOM", function (props_data) {
            if (props_data.call_flag_name == "INCOMING_CALL") {
            var data = {
                call_flag_name: props_data.call_flag_name,
                room_id: Number(props_data.room_id),
                callerList: props_data.callerList,
            }
                _this.setState({ calling: true, calling_mode: "INCOMING_CALL", room_id: data.room_id, incomming_data: data })
            }
            else if (data.call_flag_name == "DISCONNECTED") {
                _this.disconnectedCallers(data.callerList)
            }
            else if (data.call_flag_name == "ACCEPTED") {
                _this.setState({ calling: false })
                if (_this.state.Callers.find(raw => raw.id == data.callerList[0].id == undefined)) {
                    _this.state.Callers.push(data.callerList[0])
                }
                if (_this.state.calling_mode == "ACCEPTED") {
                    _this.setState({ calling: true, room_id: data.room_id })

                } else {
                    _this.setState({ calling: true, calling_mode: "ACCEPTED", room_id: data.room_id })

                }
            }
            else if (data.call_flag_name == "CALL_ROOM") {
                _this.setState({ calling: false })
                _this.setState({ Callers: data.callerList })

            }
            else if (data.call_flag_name == "ROOM_ERROR") {
                _this.RemoveOldToUserHistory()
            }
        });
    }

    callInitiation = (to_calling_obj) => {
        this.setState({ calling: true, calling_mode: "INITIATE_CALL", to_calling_obj: to_calling_obj })
    }
    closePopup = () => {
        this.setState({ calling: false, room_id: 0, to_calling_obj: undefined, calling_mode: "" })
    }
    updateRoomId = (room_id) => {
        this.setState({ room_id: room_id })
    }
    disconnectedCallers = (callers) => {
        if (Array.isArray(callers)) {
            if (callers.length == 1) {
                var temp_index = this.state.Callers.findIndex(raw => raw.id == callers[0].id);
                if (temp_index != -1) {
                    this.state.Callers.splice(temp_index, 1);
                    this.setState(this.state)
                }
            }
        }
    }
    updateCallers = (callers) => {
        this.state.to_calling_obj.callers = callers
        this.setState(this.state)
    }
    //Date Format 2022-07-27 
    formatDate = (date) => {
        let d = new Date(date);
        let month = (d.getMonth() + 1).toString();
        let day = d.getDate().toString();
        let year = d.getFullYear();
        if (month.length < 2) {
        month = '0' + month;
        }
        if (day.length < 2) {
        day = '0' + day;
        }
        return [year, month, day].join('-');
    }
    callAccept = async () => {
        var _this = this;
        let headers = {
            'Content-Type': 'application/json',
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
          }
        var data = {
            user_id: ud.id,
            session_id: ud.session_id,
            room_id: this.state.room_id
        }
        axios.post(`${SERVER_IP}/callaccept`, data, { withCredentials: true, headers: headers })
            .then(function (response) {  
                if (response.data.error === false) {
                    const sendData = {
                        error: false,
                        message_status: "Message sent successfully",
                        event: 'SEND_MESSAGE',
                        chat_type: 'TEXT',
                        from_id: ud.id,
                        to_id: response.data.room_id,
                        room_id: response.data.room_id,
                        data: [{
                          nonremovable: true,
                          datetime: _this.formatDate(new Date())+" "+new Date().toLocaleTimeString(),
                          message: `${ud.username} has joined the meeting`,
                          message_id: "",
                          message_type: 'TEXT',
                          file: "",
                          from_name: ud.username,
                          to_name: "",
                          from_email: ud.email,
                          to_email: "",
                          from_icon: ud.cooperate_logo.split('/icons/')[1],
                          to_icon: "",
                          from_user_id: ud.id,
                          from_profile: "",
                          to_profile: "",
                          to_user_id: response.data.room_id,
                          message_thumbnail: "",
                          readStatus: ""
                        }]
                    }
                    socket.emit('VEDIO_B_MESSAGE_EVENT', sendData)
                    _this.setState({ calling: false })
                    _this.setState({
                        calling: true,
                        calling_mode: "ACCEPTED",
                        room_id: response.data.room_id,
                    })
                } else {
                    swal(response.data.flag_name);
                    _this.closePopup()
                }

            })
            .catch(function (error) {
                swal("Something Went Wrong,Please Retry")
            });
    }
    callDecline = (disconnect_type) => {
        var _this = this;

        var requestData = {
            user_id: ud.id,
            room_id: this.state.room_id,
            disconnect_type: disconnect_type
        }
        axios.post(`${SERVER_IP}/calldisconnected`, requestData)
            .then(function (response) {
                if (response.data.error === false) {
                    _this.closePopup();

                    swal(response.data.flag_name);
                } else {
                    swal(response.data.flag_name);
                    _this.closePopup()
                }

            })
            .catch(function (error) {
                swal("Something Went Wrong,Please Retry")
            });
    }
    
    render() {
        if (ud) {
            if (ud.usertype === 3) {
                return (
                    <>
                        {this.state.calling ?
                            <CallManager
                                socket={this.props.socket}
                                updateCallers={this.updateCallers}
                                updateRoomId={this.updateRoomId}
                                calling_mode={this.state.calling_mode}
                                to_calling_obj={this.props.to_calling_obj}
                                callError={this.closePopup}
                                room_id={this.state.room_id}
                                incomming_data={this.state.incomming_data}
                                callAccept={this.callAccept}
                                callDecline={this.callDecline}
                                Callers={this.state.Callers}
                            />
                            : null}
                    </>
                )
            }
        }
        else {
            return (<div></div>)
        }
    }
}
export default CallingChannel